import { render, staticRenderFns } from "./gasLeakDetectionAlarmInfoDetail.vue?vue&type=template&id=44d06d27"
import script from "./gasLeakDetectionAlarmInfoDetail.vue?vue&type=script&lang=js"
export * from "./gasLeakDetectionAlarmInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d06d27')) {
      api.createRecord('44d06d27', component.options)
    } else {
      api.reload('44d06d27', component.options)
    }
    module.hot.accept("./gasLeakDetectionAlarmInfoDetail.vue?vue&type=template&id=44d06d27", function () {
      api.rerender('44d06d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/glda/gasLeakDetectionAlarmInfoDetail.vue"
export default component.exports